import { useLayoutEffect, useMemo, useEffect, useState } from 'react'
import { Container, Row, Col, } from 'react-bootstrap'
import useLayout from '#Context/Layout'
import { Link } from 'react-router-dom';
import drawTabletHome from './home.tablet.js'
// import drawWideHome from './home.wide.js' //replaced
import OptionBtn from './OptionBtn.js';
import Card from '#Components/Card'
import homeStyle from './home.lazy.css'



let linkData = [
    { icon: 'clipboard-list', msg: 'Résumé', path: '/resume' },
    { icon: 'comments', msg: 'Contact Me', path: '/contact' },
    { icon: 'tools', msg: 'Projects', path: '/projects' },
    { icon: 'dna', msg: 'About Me', path: '/about' },
    { icon: 'blog', msg: 'Dev Blog', path: '/blog' },
]

export default function Home() {
    // console.log('Home render')

    const { platform } = useLayout();

    useLayoutEffect(() => {
        homeStyle.use();
        return () => homeStyle.unuse();
    }, [])

    useEffect(() => {
        // console.log('home useEffect')
        switch (platform) {
        case 'desktop':
            // drawWideHome();
            break;
        case 'tablet':
        case 'mobile':
        default:
            drawTabletHome();
            break;
        }
    }, [platform])

    const resizer = useMemo(() => {
        switch (platform) {
        case 'desktop':
            // return drawWideHome;
            return () => { };
        case 'mobile':
        case 'tablet':
        default:
            return drawTabletHome
        }
    }, [platform])

    useLayoutEffect(() => {
        window.addEventListener('resize', resizer)
        return () => window.removeEventListener('resize', resizer)
    }, [resizer])

    // useEffect(() => {
    //     if (platform === 'desktop') {
    //         let slider = document.querySelector('.slider0')
    //         slider.style.height = '87vh'
    //         slider.style.width = '100vw'
    //         setTimeout(() => {
    //             slider.style.overflow = 'overlay'
    //             slider.style.transitionProperty = 'none'
    //         }, 1200)
    //     }
    // }, [platform])

    const content = useMemo(() => {
        return {
            header: {
                headText: "Welcome!",
                icon: 'home',
                w0: 86,
                h0: 77,
            },
            id: 'homeThing',
            // href: '#statement',
            Element: function () {
                return (
                    <div className="d-flex flex-column rocky" style={{ /*maxWidth: '50vw',*/ maxWidth: '700px' }}>
                        <h5 className=" mt-3 mb-4 align-self-center" style={{}} >Thanks for checking out my developer portfolio!</h5>
                        <div className="d-flex mb-2">
                            <Link to="/resume" className="mx-4 mb-0 align-self-center iconLink"><h5 className="fa fa-clipboard-list"></h5></Link>
                            <h5 className="mb-0 mt-2 ">Looking for a new full-stack web developer? View or download a copy of my <Link to="/resume" className="primary">Résumé</Link>.</h5>
                        </div>
                        <div className="d-flex mb-2">
                            <Link to="/resume" className="mx-4 mb-0 align-self-center iconLink"><h5 className="fa fa-tools"></h5></Link>
                            <h5 className="mb-0 mt-2 ">If you want to see some examples of my work-product, head on over to <Link to="/projects" className="primary">Projects</Link>.</h5>
                        </div>
                        <div className="d-flex mb-2">
                            <Link to="/resume" className="mx-4 mb-0 align-self-center iconLink"><h5 className="fa fa-dna"></h5></Link>
                            <h5 className="mb-0 mt-2 ">If you're curious about my story, you can read my personal statement and more in <Link to="/about" className="primary">About Me</Link>.</h5>
                        </div>
                        <div className="d-flex mb-2">
                            <Link to="/resume" className="mx-4 mb-0 align-self-center iconLink"><h5 className="fa fa-blog"></h5></Link>
                            <h5 className="mb-0 mt-2 ">While you're here, check out my <Link to="/blog" className="primary">Developer Blog</Link>. I began writing these instructional articles during my time as a tutor for The Last Mile</h5>
                        </div>
                        <div className="d-flex mb-2">
                            <Link to="/resume" className="mx-4 mb-0 align-self-center iconLink"><h5 className="fa fa-comments"></h5></Link>
                            <h5 className="mb-0 mt-2 ">Ready to get down to business? <Link to="/contact" className="primary">Contact Me</Link> and let's get started!</h5>
                        </div>
                    </div>
                )
            }
        }
    }, [])


    if (platform !== 'desktop') {
        return (
            <>
                <div id="home" className="position-relative mt-5" style={{ height: '50vh', border: 'none' }}>
                    <canvas id="homeCanvas" className="position-absolute" style={{ width: '100%', height: '100%' }}></canvas>
                    {linkData.map((item, idx) => OptionBtn(item, idx, platform))}
                </div>
                <div id="homeBlurb" className={`position-relative m-5 mt-0 mt-sm-5 p-5 d-flex flex-column ${platform}`} >
                    <h1 className="align-self-center rocky">Welcome!</h1>
                    <h2 className="align-self-center rocky mt-3" style={{ textAlign: 'center' }}>Thanks for checking out my developer portfolio.</h2>
                </div>
            </>
        )
    }
    else {
        return (
            // <>
            //     <div id="home" className="position-relative" style={{ height: '87vh', border: 'none', width: '100vw' }}>
            //         <div className="slider0" style={{ height: '0', width: '0', overflow: 'hidden' }}>
            //             <div className="slider1 position-relative d-flex justify-content-center" style={{ width: '98vw', height: '87vh', padding: '12vh 0' }}>
            //                 <ScrollingCard type={0} header={{headText: `Welcome!`}} id="homeThing" w0={86} h0={77} Element={HomeContent}>
            //                 </ScrollingCard>
            //             </div>
            //         </div>
            //     </div>
            // </>
            <Container className="pt-0 rocky h-100" fluid id="wideHome">
                <Row className="h-100">
                    <Col id="resumeLeft" className="px-3 d-flex align-items-center" xs={{ span: 6, offset: 3 }} style={{ paddingTop: '20px' }}>
                        <Card {...{ ...content, classString: "mb-5", index: 0 }} ></Card>
                    </Col>
                </Row>
            </Container>
        )
    }
}


